import React, { Component } from 'react'
import page from 'page'
import moment from "moment"

export default class ProfileAuctionCard extends Component {
  render() {
    const { data, back } = this.props
    return (
      <div className='ProfileContainer'>
          <div className='ProfileContainer__wrapper'>
              <div className='ProfileContainer__header'>
                  <img className='ProfileContainer__header-arrow' src="/assets/img/arrow.png" onClick={back} alt="" />
                   <p className='ProfileContainer__header-left'>{moment(data.startDate).add(3, 'hours').utc().format('Аукцион от DD/MM/YYYY')}</p>
                  <p className='ProfileContainer__header-right'>аукцион завершится {moment(data.closeDate).fromNow()}</p>
              </div>
              <div className='ProfileContainer__main ProfileContainer__main_grid'>
                <div className='ProfileContainer__output'>
                  <p className='ProfileContainer__output-top'>Статус</p>
                  <div  className='ProfileContainer__output-main'>
                    {data.status ==="active" ? "Активный" : ""}
                  </div>
                </div>
                <div className='ProfileContainer__output'>
                  <p className='ProfileContainer__output-top'>Дата завершения</p>
                  <div  className='ProfileContainer__output-main'>
                    {moment(data.closeDate).format("DD/MM/YYYY")}
                  </div>
                </div>
                <div className='ProfileContainer__output'>
                  <p className='ProfileContainer__output-top'>Фонд</p>
                  <div  className='ProfileContainer__output-main'>
                    {data.fund}
                  </div>
                </div>
              </div>
          </div>
          <div className='ProfileContainer__transit'>
                <p className='ProfileContainer__transit-text'>
                    Перейти на сайт, чтобы посмотреть описание лота
                </p>
                <img className='ProfileContainer__header-arrow' src="/assets/arr/right-arrow.svg" onClick={() => page(`/lots/${data._id}`)} alt="" />
            </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PersonProfile/ProfileContainers/ProfileAuctionCard.jsx